/**
 * Custom functionality for the homepage.
 */

/* global jQuery, TweenMax, TimelineLite, Back, Bounce, Elastic */

const $                 = jQuery;   // jQuery loaded via WordPress enqueue process
const events            = require('../utilities/events');
const clippedParallax   = require('../components/clipped-parallax');



/**
 * Init any parallax modules on the page
 */
function initClippedParallax() {
    // Set up 'Our Story' background parallax
    let paraOptions1 = {
        container:          '.home-our-story',
        bg:                 '.home-our-story__bg',
        svg:                '.home-our-story__bg-svg',
        image:              '.home-our-story__bg-image',
        clipPath:           '#home-our-story__bg-clip-path',
        clipShape:          '#home-our-story__bg-clip-shape',
        clipPathWidth:      1366,
        clipPathHeight:     800,
        imageWidth:         1366,
        imageHeight:        800,
        intensity:          0.5,    // 0 - minimal effect | larger values increase effect           
        bottomAnchor:       false    
    };
    clippedParallax.setupParallax(paraOptions1); 

    // Set up 'Locations' background parallax
    let paraOptions2 = {
        container:          '.home-locs',
        bg:                 '.home-locs__bg',
        svg:                '.home-locs__bg-svg',
        image:              '.home-locs__bg-image',
        clipPath:           '#home-locs__bg-clip-path',
        clipShape:          '#home-locs__bg-clip-shape',
        clipPathWidth:      1366,
        clipPathHeight:     800,
        imageWidth:         1366,
        imageHeight:        1000,
        intensity:          0.5,    // 0 - minimal effect | larger values increase effect
        bottomAnchor:       true    // Anchor bg at bottom of container (to be used with
                                    // css definition to bottom align bg block)           
    };
    clippedParallax.setupParallax(paraOptions2); 
}


function initAnimations() {
    // Our text animation is comprised of a series of span elements,
    // each representing a word in a phrase.  The spans display a
    // portion of a background image, spelling out the phrase. Here,
    // we scale down the container based on the available screen
    // width, and keep it centered.  This allows us to maintain
    // the exact word placement and background positioning.
    let $animModule = $('.home-our-story__anim'),
        $animInnerWrap = $('.home-our-story__anim-inner'),
        imgWidth = 536;     // Based on 'master' size of scaled down graphic (at 1/2 x)

    // Set a fixed width on the container 
    $animInnerWrap.css('width', imgWidth + 'px');

    $(window).resize(() => {
        let parentWidth = $animModule.width(),
            parentWidthWithPadding = $animModule.innerWidth(),
            targetWidth = (parentWidth > imgWidth) ? imgWidth : parentWidth,
            scaleRatio = targetWidth / imgWidth,
            leftLoc = (parentWidth > imgWidth) 
                ? (parentWidthWithPadding - imgWidth) / 2 
                : (parentWidthWithPadding - parentWidth) / 2;

        $animInnerWrap.css('transform', 'scale(' + scaleRatio + ')').css('left', leftLoc + 'px');
    }).trigger('resize');

    // Prep our reveal animations
    let $word1 = $('.home-our-story__anim-element:nth-child(1)'),
        $word2 = $('.home-our-story__anim-element:nth-child(2)'),
        $word3 = $('.home-our-story__anim-element:nth-child(3)'),
        $word4 = $('.home-our-story__anim-element:nth-child(4)'),
        $word5 = $('.home-our-story__anim-element:nth-child(5)'),
        $word6 = $('.home-our-story__anim-element:nth-child(6)'),  // "NO" - left burst
        $word7 = $('.home-our-story__anim-element:nth-child(7)'),  // "NO"
        $word8 = $('.home-our-story__anim-element:nth-child(8)'),  // "NO" - right burst
        $blurb = $('.home-our-story__text'),
        $cta   = $('.home-our-story .button');

    // Hide the bottom red dash on our animation text block to start
    $animModule.addClass('hide-bottom-dash');

    // Set up our animation sequence, paused at start
    let ourStoryAnim = new TimelineLite({ paused: true });
    ourStoryAnim.staggerFrom([$word1, $word2, $word3, $word4, $word5], 0.5, { x: 100, alpha: 0 }, 0.1)
        .from($word7, .5, {alpha:0, scale:0, ease: Back.easeOut, onComplete:function() {
            $animModule.removeClass('hide-bottom-dash');
        }}, '-=0.5')
        .from($word6, .35, { alpha: 0, scale: 0, ease: Back.easeOut, x:150}, '-=0.5')
        .from($word8, .35, { alpha: 0, scale: 0, ease: Back.easeOut, x:-150}, '-=0.5')
        .staggerFrom([$blurb, $cta], 1, {alpha: 0, y:20}, 0.2);

    // Listen for reveal events (via ScrollReveal)
    $('body').on(events.REVEAL_START, (evt, domEl) => {
        let $el = $(domEl);
        if ($el.hasClass('home-our-story')) {
            setTimeout(() => {
                ourStoryAnim.play();
            }, 1200);
        }
    });
}

// Set up a listener for slider change events.  We want to track
// the progression of slide changes in the slider, and pause 
// when we get to the second slide on the third time around.
function initSliderWatch() {
    let targetSlideIndex = 1,   // Slide 2 
        targetSlideCount = 0;

    // Listen for slide change events (via ScrollReveal)
    $('body').on(events.SLIDE_CHANGE, (evt, nextSlide) => {
        if (nextSlide == targetSlideIndex) {
            if (targetSlideCount < 2) {
                // Not time to stop yet...
                targetSlideCount++;
            } else {
                // Otherwise, let's pause the slideshow
                // Dispatch an event/request
                $('body').trigger(events.REQUEST_SLIDER_PAUSE);
            }
        }
    });
}


exports.init = function () {
    initSliderWatch();
    initClippedParallax();
    initAnimations();
};